import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Button } from 'formlabs-web-components/Link';

const CheckoutButton = ({ cartId, storeId, withArrow }) => {
  const checkoutPage = `${
    process.env.RAZZLE_MAGENTO_URL
  }/${storeId}/checkout/cart?cartId=${cartId}`;
  const [t] = useTranslation();

  return (
    <Button to={checkoutPage} arrow={withArrow && 'right'}>
      {t('Checkout')}
    </Button>
  );
};

export default connect(state => {
  return { cartId: get(state, 'cart.id'), storeId: get(state, 'store.id') };
})(CheckoutButton);
